<template>
    <HeroBlock :model="hero" />
    <HeroOverlayCard v-if="(heroOverlay ?? []).length > 0"
        :model="pageStore.getLinkedItem<HeroOverlayCardModel>(heroOverlay[0])" />
    <RichText :value="content" />
</template>
<script setup lang="ts">
import type { HeroModel, HeroOverlayCardModel, InteriorPageModel } from '~/models';
const pageStore = usePageStore()
const page = pageStore.page as InteriorPageModel
const content = ref(page?.elements.content.value)
const heroOverlay = page?.elements.heroOverlay.value
const hero = ref<HeroModel | undefined>(undefined)
if ((page?.elements.hero.value ?? []).length > 0) {
    hero.value = pageStore.getLinkedItem<HeroModel>((page?.elements?.hero?.value ?? [])[0])
}

const showGlobalContentBlockState = useState<boolean>('showGlobalContentBlockState');
const showGlobalContentBlock = firstOrDefault(page.elements?.showGlobalContactBlock?.value);

if (showGlobalContentBlock) {
    showGlobalContentBlockState.value = multipleChoiceToBoolean(page.elements.showGlobalContactBlock)
}
else {
    // default should be true
    showGlobalContentBlockState.value = true;
}


</script>

<style scoped></style>
